<template>
  <el-input
    v-model="value"
    :disabled="disabled"
    type="text"
    @update:modelValue="input"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'RemoteVideoInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const input = (newValue: string) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { input, value }
  }
})
</script>
